<script setup lang="ts">
import AuthContainer from './components/AuthContainer.vue'
import AuthNewsPanel from './components/AuthNewsPanel.vue'

const SUPPORT_EMAIL = 'support@heypongo.com'
const GRADIENTS = [
  '/images/pongo-gradient-bg.webp',
  '/images/pongo-gradient-pink.webp',
  '/images/pongo-gradient-green.webp'
]

const { t } = useI18n()

const steps = computed(() => [t('accountBlocked.steps.1'), t('accountBlocked.steps.2'), t('accountBlocked.steps.3')])
</script>

<template>
  <AuthContainer
    :should-show-redirect-to-login-link="false"
    :title="t('accountBlocked.title')"
    :subtitle="t('accountBlocked.subtitle')"
  >
    <div class="space-y-6 text-sm font-[300] text-foreground">
      <p>{{ t('accountBlocked.intro') }}</p>

      <ol class="space-y-3">
        <li v-for="(step, index) in steps" :key="index" class="flex gap-3">
          <span
            class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary"
          >
            {{ index + 1 }}
          </span>
          <span class="pt-0.5">{{ step }}</span>
        </li>
      </ol>

      <p>{{ t('accountBlocked.reassurance') }}</p>
    </div>

    <template #footer>
      <div class="space-y-4">
        <Button variant="default-primary" size="xl" class="w-full" as-child>
          <a :href="`mailto:${SUPPORT_EMAIL}`">
            {{ t('accountBlocked.contactSupport') }}
          </a>
        </Button>
        <p class="text-center text-sm text-muted-foreground">
          {{ t('accountBlocked.or') }}
          <router-link
            :to="{ name: 'Login' }"
            class="font-medium text-cta underline underline-offset-4 hover:text-cta/70"
          >
            {{ t('accountBlocked.backToLogin') }}
          </router-link>
        </p>
      </div>
    </template>

    <template #aside>
      <AuthNewsPanel
        :images="GRADIENTS"
        :label="t('accountBlocked.aside.label')"
        :title="t('accountBlocked.aside.title')"
        :subtitle="t('accountBlocked.aside.subtitle')"
      />
    </template>
  </AuthContainer>
</template>
